// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { batchTypeEnum } from './BatchTypeEnum';
import { operatorId } from './Operator';
import { equipmentTypeId } from './EquipmentType';
import { harvestOperationTemplateId } from './HarvestOperationTemplate';
import { z } from 'zod';
export const harvestOperationTemplateRevisionId = (z.number());
export const harvestOperationTemplateRevision = z.object({
    id: harvestOperationTemplateRevisionId,
    description: z.string().nullable(),
    icon: z.string().nullable(),
    output_materials: z.array(batchTypeEnum).nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    equipment_type_id: equipmentTypeId.nullable(),
    template_id: harvestOperationTemplateId,
    is_draft: z.boolean(),
    previous_revision_id: harvestOperationTemplateRevisionId.nullable(),
    is_correction_draft: z.boolean(),
    correction_source_revision_id: harvestOperationTemplateRevisionId.nullable(),
    dashboard_layout: z.unknown(),
    tracked_output_material: batchTypeEnum.nullable(),
    accepted_input_phases: z.string().array(),
});
export const harvestOperationTemplateRevisionInitializer = z.object({
    id: harvestOperationTemplateRevisionId.optional(),
    description: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    output_materials: z.array(batchTypeEnum).optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    equipment_type_id: equipmentTypeId.optional().nullable(),
    template_id: harvestOperationTemplateId,
    is_draft: z.boolean().optional(),
    previous_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    is_correction_draft: z.boolean().optional(),
    correction_source_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    dashboard_layout: z.unknown().optional(),
    tracked_output_material: batchTypeEnum.optional().nullable(),
    accepted_input_phases: z.string().array().optional(),
});
export const harvestOperationTemplateRevisionMutator = z.object({
    id: harvestOperationTemplateRevisionId.optional(),
    description: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    output_materials: z.array(batchTypeEnum).optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    equipment_type_id: equipmentTypeId.optional().nullable(),
    template_id: harvestOperationTemplateId.optional(),
    is_draft: z.boolean().optional(),
    previous_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    is_correction_draft: z.boolean().optional(),
    correction_source_revision_id: harvestOperationTemplateRevisionId.optional().nullable(),
    dashboard_layout: z.unknown().optional(),
    tracked_output_material: batchTypeEnum.optional().nullable(),
    accepted_input_phases: z.string().array().optional(),
});
//# sourceMappingURL=HarvestOperationTemplateRevision.js.map